import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQ {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  faqs: FAQ[];
}
export function FAQAccordion({
  faqs
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto flex flex-col gap-4" data-id="element-85">
      {faqs.map((faq, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className={`bg-paper border rounded-2xl overflow-hidden transition-colors duration-200 ${isOpen ? 'border-storm-red shadow-md' : 'border-subtle-gray shadow-sm hover:border-gray-warm'}`} data-id="element-86">
            <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-87">
              <span className="font-bold text-lg text-ink pr-8" data-id="element-88">
                {faq.question}
              </span>
              <ChevronDown className={`w-6 h-6 text-storm-red shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-89" />
            </button>
            <AnimatePresence initial={false} data-id="element-90">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-91">
                  <div className="px-6 pb-6 text-gray-warm leading-relaxed" data-id="element-92">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}